import { useSessionState } from './useSessionState';

export type ViewMode = 'table' | 'card';

export const useViewMode = (contextKey: string): [ViewMode, (mode: ViewMode) => void] => {
  return useSessionState<ViewMode>(`viewMode:${contextKey}`, 'table');
};
